import { motion } from "motion/react";
import { useState, useEffect, useMemo } from "react";
import Loading from "../Loading";

export default function FullLoading() {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const messageArray = useMemo(
    () => [
      "Chargement",
      "Encore un petit instant...",
      "Patientez un peu...",
      "C'est presque fini...",
      "Patientez encore un peu...",
      "Ça vaut le coup...",
      "...",
    ],
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentMessageIndex === messageArray.length - 1) {
        setCurrentMessageIndex(0);
      } else {
        setCurrentMessageIndex((prev) => prev + 1);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [currentMessageIndex, messageArray]);

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-8">
      <div className="flex">
        <Loading />
      </div>

      <motion.div
        key={currentMessageIndex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="text-secondary"
      >
        {messageArray[currentMessageIndex]}
      </motion.div>
    </div>
  );
}
